import styled from 'styled-components'
import { MediaBreakpoint } from 'root-constants'
import { desktopMediaQuery, salesDesktopMediaQuery } from 'nove8/components/styles'

export interface IProps {
  disabled?: boolean
}

export const OptionContainerVariant2 = styled.label<IProps>`
  cursor: pointer;
  display: block;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

  & > input {
    display: none;
  }

  [data-is-multiple='true'] & {
    width: calc(50% - 10px);
  }

  opacity: ${(props) => (props.disabled ? '50%' : 1)};
`
const desktopMediaQueryVC = `(min-width: ${MediaBreakpoint.TABLET}px)`

export const StyledOption = {
  OptionsContainer: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 120px;

    &[data-is-multiple='true'] {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }

    @media ${desktopMediaQuery} {
      margin-bottom: 24px;
    }
  `,
  OptionsContainer2: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 120px;
    justify-content: center;
    height: 100%;
    gap: 10px;

    &[data-is-multiple='true'] {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }

    @media ${desktopMediaQuery} {
      margin-bottom: 24px;
      justify-content: start;
    }
  `,
  OptionsContainer2VC: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 120px;
    justify-content: center;
    height: 100%;
    gap: 10px;

    &[data-is-multiple='true'] {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }

    @media (min-width: ${MediaBreakpoint.PHONE_WITH_390_MIN}px) {
      margin-bottom: 140px;
    }

    @media ${desktopMediaQueryVC} {
      margin-bottom: 24px;
      justify-content: start;
    }
  `,
  OptionsContainer390: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 10px;
    overflow-y: auto;

    &[data-is-multiple='true'] {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }

    @media ${desktopMediaQueryVC} {
      margin-bottom: 24px;
      justify-content: start;
    }

    @media (min-width: ${MediaBreakpoint.PHONE_WITH_390_MIN}px) {
      margin-top: 27px;
      margin-bottom: 0;
      justify-content: start;
    }
  `,
   OptionsContainerHog: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 120px;
    justify-content: start;
    height: 100%;
    gap: 10px;

    &[data-is-multiple='true'] {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }

    @media ${salesDesktopMediaQuery} {
      margin-bottom: 24px;
      justify-content: start;
    }
  `,
  OptionsContainer4: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 120px;
    justify-content: center;
    height: 100%;

    @media ${desktopMediaQuery} {
      justify-content: start;
    }
  `,
  OptionsContainer5: styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    overflow-y: auto;
  `,
  OptionsContainer7: styled.div`
    width: 328px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;

    @media ${desktopMediaQuery} {
      width: 382px;
    }
  `,
  OptionsContainer6: styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    flex-direction: column;
    overflow-y: auto;
  `,
  OptionsContainerPT: styled.div<{ isAddMargin?: boolean }>`
    width: 100%;
    display: flex;
    gap: 10px;
    flex-direction: column;
    overflow-y: auto;
    ${({ isAddMargin }) => isAddMargin && 'margin-bottom: 120px'};
  `,
  CommandsContainer: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 72px;
    margin-bottom: 120px;
    justify-content: center;
    height: 100%;
    gap: 10px;

    &[data-is-multiple='true'] {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }
  `,
  OptionsContainer3: styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;

    @media ${desktopMediaQuery} {
      justify-content: start;
    }
  `,
  OptionsImagesContainer: styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;

    @media ${desktopMediaQueryVC} {
      justify-content: start;
    }
  `,
  OptionContainer: styled.label`
    cursor: pointer;
    display: block;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

    & > input {
      display: none;
    }

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    [data-is-multiple='true'] & {
      width: calc(50% - 4px);

      &:nth-child(2n + 1) {
        margin-right: 8px;
      }
    }
  `,
  OptionContainer3: styled.label`
    cursor: pointer;
    display: block;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

    & > input {
      display: none;
    }
  `,
  OptionsContainer8: styled.label<IProps>`
    ${OptionContainerVariant2};

    & > input {
      display: none;
    }

    @media (min-width: ${MediaBreakpoint.QUESTIONS_DESKTOP}px) {
      width: calc(50% - 10px);
    }
  `,
  PaymentOptionContainer: styled.div`
    cursor: pointer;
    display: block;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

    & > input {
      display: none;
    }

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    [data-is-multiple='true'] & {
      width: calc(50% - 4px);

      &:nth-child(2n + 1) {
        margin-right: 8px;
      }
    }
  `,
}
